"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { Suspense } from "react";
import { AdminSidebar } from "@/components/admin-sidebar/admin-sidebar";
import { AppSidebar } from "@/components/app-sidebar/app-sidebar";
import { AssistantPanelProvider } from "@/components/assistant/assistant-panel";
import { EnforceOrganization } from "@/components/enforce-organization";
import { PageWrapperLoading } from "@/components/page-wrapper";
import { SupportDialogProvider } from "@/components/support/support-dialog";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { extractOrganizationSlug } from "@/lib/organization-path";
interface AppShellProps {
  children: ReactNode;
  defaultSidebarOpen?: boolean;
}
export function AppShell(t0) {
  const $ = _c(16);
  const {
    children,
    defaultSidebarOpen
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pathname.startsWith("/admin");
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isAdminRoute = t1;
  const organizationSlug = extractOrganizationSlug(pathname);
  const isOrganizationRoute = Boolean(organizationSlug);
  if (!isAdminRoute && !isOrganizationRoute) {
    return children;
  }
  let t2;
  if ($[2] !== children || $[3] !== isAdminRoute) {
    t2 = isAdminRoute ? children : <Suspense fallback={<PageWrapperLoading />}><EnforceOrganization>{children}</EnforceOrganization></Suspense>;
    $[2] = children;
    $[3] = isAdminRoute;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const content = t2;
  let t3;
  if ($[5] !== isAdminRoute) {
    t3 = isAdminRoute ? <Suspense><AdminSidebar /></Suspense> : <AppSidebar />;
    $[5] = isAdminRoute;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== content) {
    t4 = <SidebarInset className="bg-background min-h-0 overflow-hidden">{content}</SidebarInset>;
    $[7] = content;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== defaultSidebarOpen || $[10] !== t3 || $[11] !== t4) {
    t5 = <SidebarProvider className="h-screen overflow-hidden" defaultOpen={defaultSidebarOpen}>{t3}{t4}</SidebarProvider>;
    $[9] = defaultSidebarOpen;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const shell = t5;
  let t6;
  if ($[13] !== isAdminRoute || $[14] !== shell) {
    t6 = <SupportDialogProvider>{isAdminRoute ? shell : <AssistantPanelProvider>{shell}</AssistantPanelProvider>}</SupportDialogProvider>;
    $[13] = isAdminRoute;
    $[14] = shell;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}